import {darkTheme} from './dark/darkTheme';
import {lightTheme} from './light/lightTheme';
import {UserTheme} from './userThemeProvider';
import {UserThemesEnum} from './userThemesEnum';

export const userThemeMap: Record<UserThemesEnum, UserTheme> = {
  [UserThemesEnum.LIGHT]: lightTheme,
  [UserThemesEnum.DARK]: darkTheme,
};

export const findTheme = (themeSetting: UserThemesEnum) => userThemeMap[themeSetting];
